import { REFERRALS } from 'common/constants/copy';

import type { Common_GetReferralSettingsQuery } from 'common/generated/graphql';

type Options = {
  isReferralsV2Active?: boolean;
};

export const formatReferralCode = (code: string) => `https://www.monarchmoney.com/referral/${code}`;

// Query params are stripped from iOS when sharing via text/email
export const appendSourceToReferralLink = (referralLink: string, source: string) =>
  `${referralLink}?r_source=${source}`;

export const getShareXUrl = (url: string, { isReferralsV2Active }: Options = {}) => {
  const body = isReferralsV2Active
    ? REFERRALS.REFERRALS_V2.SHARE_TWEET_BODY(url)
    : REFERRALS.SHARE_TWEET_BODY(url);
  return `https://x.com/intent/tweet?text=${encodeURIComponent(body)}`;
};

export const getShareFacebookUrl = (url: string, { isReferralsV2Active }: Options = {}) =>
  `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodeURIComponent(
    isReferralsV2Active ? REFERRALS.REFERRALS_V2.GENERAL_SHARE_BODY : REFERRALS.GENERAL_SHARE_BODY,
  )}`;

export const getShareLinkedInUrl = (url: string) =>
  `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`;

export const getShareMailUrl = (url: string, { isReferralsV2Active }: Options = {}) => {
  const subject = REFERRALS.GENERAL_SHARE_SUBJECT;
  const body = `${
    isReferralsV2Active ? REFERRALS.REFERRALS_V2.GENERAL_SHARE_BODY : REFERRALS.GENERAL_SHARE_BODY
  } ${url}`;
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

export const getShareTextUrl = (url: string, { isReferralsV2Active }: Options = {}) => {
  const body = `${
    isReferralsV2Active ? REFERRALS.REFERRALS_V2.GENERAL_SHARE_BODY : REFERRALS.GENERAL_SHARE_BODY
  } ${url}`;
  return `sms:?body=${encodeURIComponent(body)}`;
};

export const withLegacyStatisticsValues = ({
  legacyReferralStatistics,
}: {
  legacyReferralStatistics?: Common_GetReferralSettingsQuery['legacyReferralStatistics'];
}) => {
  if (!legacyReferralStatistics) {
    return false;
  }

  return (
    legacyReferralStatistics.creditsEarned > 0 ||
    legacyReferralStatistics.signedUp > 0 ||
    legacyReferralStatistics.subscribed > 0
  );
};
